import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import Icon from "@/components/ds/icon/Icon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Ok',
  props: {
    size: {
        type: Number,
        default: 16,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "Ok",
    style: _normalizeStyle({ '--size': __props.size + 'px' })
  }, [
    _createVNode(Icon, { "icon-id": "check" })
  ], 4))
}
}

})